import React from "react";
import { IconProps } from "../icon";

export const Headphones_01Icon = ({ size = "24px", color = "#000", ...props }: IconProps<string, string>) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M21 18v-6a9 9 0 10-18 0v6m2.5 3A2.5 2.5 0 013 18.5v-2a2.5 2.5 0 015 0v2A2.5 2.5 0 015.5 21zm13 0a2.5 2.5 0 01-2.5-2.5v-2a2.5 2.5 0 015 0v2a2.5 2.5 0 01-2.5 2.5z"
    />
  </svg>
);
